import { useState } from "react";
import { Link } from "react-router-dom";
import { Globe, Copy, Check } from "lucide-react";

export const TopBar = () => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.origin : "";
  const year = new Date().getFullYear();

  const copy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <div className="h-10 bg-[#FFD60A] text-black flex items-center justify-center gap-3 px-4 text-xs sm:text-sm font-semibold relative z-50" data-testid="site-url-bar">
      <span className="flex items-center gap-1 font-bold uppercase tracking-wide" data-testid="age-notice">
        <span className="inline-flex items-center justify-center h-4 px-1 border border-black text-[9px] leading-none rounded-sm">18+</span>
        <span className="hidden sm:inline">Adults only</span>
      </span>
      <span className="text-black/40">|</span>
      <Globe className="h-4 w-4 flex-shrink-0" />
      <span className="hidden sm:inline">Live site:</span>
      <a href={url} className="truncate underline underline-offset-2 hover:opacity-80" data-testid="site-url-link">{url}</a>
      <button onClick={copy} data-testid="copy-site-url" className="flex items-center gap-1 bg-black/15 hover:bg-black/25 px-2 py-0.5 rounded-full transition-colors">
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
        {copied ? "Copied" : "Copy"}
      </button>
      <span className="text-black/40 hidden md:inline">|</span>
      <Link to="/legal" data-testid="copyright-link" className="hidden md:inline font-bold hover:opacity-80 whitespace-nowrap">© {year} NEXTtt™</Link>
    </div>
  );
};
